// extracted by mini-css-extract-plugin
module.exports = {"root":"overlay_root__Ljl4N","visible":"overlay_visible__HwVId","enter":"overlay_enter__iWb9q","fadeIn":"overlay_fadeIn__5u1_a"};